import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-strategies',
  template: `<router-outlet></router-outlet>`,
  styles: []
})
export class StrategiesComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
